window.$ = window.jQuery = require('jquery');

require('./common/recaptchav3');
require('./common/currentLocale');
require('./common/validator');
require('./common/accordion');
require('./common/tabs');
require('./components/dropdown-select-lang');

console.log('frontend');

export default class Header {
	constructor() {
		this.header = document.querySelector("header");
		this.menu = document.querySelector(".btnMobileMenu");
		this.menuOpen = document.querySelector(".menu");
		
		this.ready();
	}

	ready() {

		this.menu.addEventListener("click", () => {
			this.menuOpen.classList.toggle("active");
			this.menu.classList.toggle("active");
			if (document.querySelector(".home")) {
				this.header.classList.toggle("active");
			} else {
				if (!this.header.classList.contains("active")) {
					this.header.classList.add("active");
				}
			}
			if (this.menu.classList.contains("active")) {
				this.header.classList.add("active");
			}
		}, false);

	}

}

new Header();